//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import headCom from "../../headCom.vue";
export default {
  components: {
    headCom: headCom
  },
  computed: {
    disabled: function disabled() {
      // 不是空 且又不是编辑的时候，禁用
      return this.ruleForm.operatorIdnum != '' && !this.editFlag;
    }
  },
  data: function data() {
    var operatorPhone = function operatorPhone(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else {
        if (/(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/.test(value)) {
          callback();
        } else {
          callback(new Error('手机号格式不正确'));
        }
      }
    };

    return {
      show: false,
      // flowId:'',
      count: '获取验证码',
      ruleForm: {
        operatorName: "",
        operatorPhone: "",
        code: "",
        operatorIdnum: ""
      },
      // disabled:false,
      rules: {
        code: [{
          required: true,
          message: "请输入验证码",
          trigger: "blur"
        }, {
          message: "验证码长度不正确",
          trigger: "blur"
        }],
        operatorPhone: [{
          required: true,
          message: "手机号不正确",
          trigger: "blur"
        }, {
          validator: operatorPhone
        }],
        operatorName: [{
          required: true,
          message: "请输入签署人姓名",
          trigger: "blur"
        }],
        operatorIdnum: [{
          required: true,
          message: "请输入签署人身份证号",
          trigger: "blur"
        }]
      },
      editFlag: true // 没有数据或者编辑的情况下为true

    };
  },
  mounted: function mounted() {
    this.requestInfo();
  },
  created: function created() {
    this.timer = null;
  },
  methods: {
    //获取验证码
    getCode: function getCode() {
      var _this = this;

      // 60秒内不重复获取
      if (this.count == '编辑') {
        this.disabled = false;
        this.count = '获取验证码';
        return;
      }

      if (this.ruleForm.operatorPhone == '' || !/[0123456789;]/g.test(this.ruleForm.operatorPhone)) {
        this.$message.error('请输入正确的手机号');
        return;
      }

      var data = {};
      data['operatorPhone'] = this.ruleForm.operatorPhone;
      data["enterpriseId"] = this.userInfo.enterpriseId;
      data["operatorIdnum"] = this.ruleForm.operatorIdnum;
      data["operatorName"] = this.ruleForm.operatorName;
      data['flag'] = typeof this.ruleForm.flowId == 'undefined' ? 0 : 1;
      this.requestAPI.addGuaranteeOperator(data).then(function (res) {
        _this.flowId = res.data;
        var TIME_COUNT = 60;

        if (!_this.timer) {
          _this.count = TIME_COUNT;
          _this.show = true;
          _this.timer = setInterval(function () {
            if (_this.count > 0 && _this.count <= TIME_COUNT) {
              _this.count--;
            } else {
              _this.show = false;
              clearInterval(_this.timer);
              _this.timer = null;
              _this.count = "获取验证码";
            }
          }, 1000);
        }
      });
    },
    // 请求配置信息
    requestInfo: function requestInfo() {
      var _this2 = this;

      this.requestAPI.selGuaranteeOperatorByEntepriseId({
        enterpriseId: this.userInfo.enterpriseId
      }).then(function (res) {
        if (res.data != null) {
          for (var key in _this2.ruleForm) {
            _this2.$set(_this2.ruleForm, key, res.data[key]);
          }

          _this2.$set(_this2.ruleForm, 'flowId', res.data.flowId);
        }

        if (_this2.ruleForm.operatorIdnum != '') {
          _this2.editFlag = false;
        }

        _this2.show = !_this2.editFlag;
      });
    },
    submitFun: function submitFun() {
      var _this3 = this;

      if (!this.ruleForm.code) {
        this.$message.error("请先输入手机验证码");
        return;
      }

      if (this.ruleForm.operatorPhone.length < 11) {
        this.$message.error("请输入正确的手机号");
        return;
      }

      if (this.ruleForm.code.length < 6) {
        this.$message.error("请输入正确的手机验证码");
        return;
      }

      this.requestAPI.verifyPhoneCodeForOperator({
        enterpriseId: this.userInfo.enterpriseId,
        code: this.ruleForm.code
      }).then(function (res) {
        _this3.$set(_this3.ruleForm, 'code', '');

        _this3.editFlag = false;
        _this3.show = !_this3.editFlag;
        _this3.count = "获取验证码";
        _this3.timer = null;
      });
    }
  }
};